// extracted by mini-css-extract-plugin
export default {"root":"ToolTip_root__nmBLi","infoIcon":"ToolTip_infoIcon__3Ef2T","superScript":"ToolTip_superScript__8ADTn"};